import { Guid } from "@app/core/constants/constants";
import { RecordState } from "@app/core/constants/global-enum";
import { RecordBaseDTO } from "@app/shared/classes/record-base";
import { IconProp } from "@fortawesome/fontawesome-svg-core";

export namespace CustomReportEditor {

  // Updated to match backend ShiftTimeRange structure
  export interface WorkingTimeRange {
    startTime: string;  // "09:00" UI format, converted to "09:00:00" for backend
    endTime: string;    // "18:00" UI format, converted to "18:00:00" for backend
  }

  export interface WorkingHoursConfig {
    enabled: boolean;
    ranges: WorkingTimeRange[];
  }

  export interface GridStateWrapper {
    devextremeState?: any; // DevExtreme grid state
    workingHours: WorkingHoursConfig; // Custom working hours config

    // Grid display ayarları
    virtualScroll?: boolean;
    expandGridRows?: boolean;
    enableCalendarDate?: boolean;

    version: string; // For future compatibility
  }

  export interface OperationResult {
    success: boolean;
    action: 'create' | 'update' | 'delete' | 'discard' | 'refresh' | 'gridState' | 'workingHoursChanged';
    report?: CustomReport;
    error?: any;
  }



  export class CustomReport extends RecordBaseDTO {

    code: string;
    name: string;
    description?: string;
    colorCode?: string;
    icon?: IconProp;
    iconColorCode?: string;

    // Tek property - her şey bunun içinde
    state: GridStateWrapper;

    dateRange?: number;
    shareRole: number;
    isPublic: boolean;
    order: number;
    groupKey?: 'Sensor' | 'Location' | 'SensorHistory' | 'LocationHistory' | 'ZoneEngagement';
    new: boolean;

    // gridStateChanged property'si - UI için
    get gridStateChanged(): boolean {
      return this.new; // Yeni rapor ise her zaman true
    }

    constructor() {
      super();
      // set defaults
      this.id = Guid.newGuid();
      this.code = '';
      this.name = '';
      this.description = '';
      this.colorCode = '';
      this.icon = ['fas', 'chart-line'];
      this.iconColorCode = '';

      // Tek state object
      this.state = {
        devextremeState: null,
        workingHours: { enabled: false, ranges: [] },
        // Grid display ayarları - default değerler
        virtualScroll: false,
        expandGridRows: false,
        enableCalendarDate: false,
        version: '1.0'
      };

      this.dateRange = 0;
      this.shareRole = 0;
      this.isPublic = false;
      this.order = 0;
      this.groupKey = 'Sensor';
      this.new = false;
    }

    // Sadece gridState - database için
    get gridState(): string {
      return JSON.stringify(this.state);
    }

    set gridState(value: string) {
      try {
        this.state = JSON.parse(value || '{}');
        // Ensure default structure
        if (!this.state.workingHours) {
          this.state.workingHours = { enabled: false, ranges: [] };
        }
        if (!this.state.version) {
          this.state.version = '1.0';
        }
        // Grid display ayarları için default değerler
        if (this.state.virtualScroll === undefined) {
          this.state.virtualScroll = false;
        }
        if (this.state.expandGridRows === undefined) {
          this.state.expandGridRows = false;
        }
        if (this.state.enableCalendarDate === undefined) {
          this.state.enableCalendarDate = false;
        }
      } catch {
        this.state = {
          devextremeState: null,
          workingHours: { enabled: false, ranges: [] },
          // Grid display ayarları - default değerler
          virtualScroll: false,
          expandGridRows: false,
          enableCalendarDate: false,
          version: '1.0'
        };
      }
    }



  }
}
